import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ModalVotarPropuesta = ({ idProyecto, tituloPropuestaVotar, isLoggedIn, onVote, navegarToVotar, showModalVotar, handleCloseModalVotar }) => {
  const handleVote = () => {
    // tengo que pasar el id del votante, el código de confirmacion y el proyecto del voto    
    onVote(idProyecto);
    handleCloseModalVotar();
  };

  const handleRegister = () => {
   navegarToVotar()
  };

  return (
    <Modal show={showModalVotar} onHide={handleCloseModalVotar}>
      <Modal.Header closeButton>
        <Modal.Title>Votar Propuesta # {idProyecto}</Modal.Title>
        
      </Modal.Header>
      <Modal.Header>
        
        <Modal.Title>{tituloPropuestaVotar}</Modal.Title>
      </Modal.Header>      
      <Modal.Body>
        {isLoggedIn ? (
          <p>¿Estás seguro que deseas votar por este proyecto?</p>
        ) : (
          <p>Necesitas iniciar sesión para poder votar por este proyecto.</p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseModalVotar}>
          Cerrar
        </Button>
        {isLoggedIn ? (
          <Button variant="primary" onClick={()=>handleVote(idProyecto)}>
            Votar
          </Button>
        ) : (
          <Button variant="primary" onClick={handleRegister}>
            Registrarme
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ModalVotarPropuesta;